import PortalDocument, {PortalDocumentInterface} from "../document/PortalDocument";
import DocumentSettings from "../document/DocumentSettings";
import PortalContext from "../PortalContext";
import Immutable from "../../shared/immutable/Immutable";
import DestinationEvent from "./DestinationEvent";
import Observer from "../../shared/class/Observer";
import LocationEvent from "./LocationEvent";
import FunctionHelper from "../../shared/helper/FunctionHelper";

enum pdfAction {
	FirstPage = "FirstPage",
	PrevPage = "PrevPage",
	NextPage = "NextPage",
	LastPage = "LastPage"
}

interface LinkServiceProperties {
	context: PortalContext;
	portalDocument: Immutable<PortalDocumentInterface>;
	locationObserver?: Observer<LocationEvent>;
	destinationObserver?: Observer<DestinationEvent>;
	numberOfPages: number;
}

export default class LinkService {
	private _externalLinkEnabled: boolean;
	private _rotation: number;
	private _page: number;
	private props: LinkServiceProperties;

	constructor(props: LinkServiceProperties) {
		this.props = props;
		this._externalLinkEnabled = true;
		this._rotation = 0;
		this._page = 1;
	}

	public get pagesCount(): number {
		return this.props.numberOfPages;
	}

	public set page(arg: number) {
		this._page = arg;
	}

	public get page(): number {
		return this._page;
	}

	public set rotation(arg: number) {
		this._rotation = arg;
	}

	public get rotation(): number {
		return this._rotation;
	}

	public async goToDestination(dest: string | any[]): Promise<void> {
		if (!FunctionHelper.exists(this.props.destinationObserver)) {
			return;
		}

		await this.props.destinationObserver!.notify({dest: dest} as DestinationEvent);
	}

	public goToPage(val: string | number): void {
		if (!FunctionHelper.exists(this.props.portalDocument?.value)) {
			return;
		}

		let portalDocument: PortalDocument = this.props.context.documentManager.findDocument(
			this.props.portalDocument.get().id!
		);
		let documentSettings: DocumentSettings = portalDocument.getSettings();

		documentSettings.activeViewer.currentPage = parseInt(FunctionHelper.applyValue(val, ""));
		this.props.context.documentManager.updateGlobalDocumentList();
	}

	public setHash(hash: string): void {
	}

	public cachePageRef(pageNum: number, pageRef: Object): void {
	}

	public isPageVisible(pageNumber: number): void {
	}

	public isPageCached(pageNumber: number): void {
	}

	public getDestinationHash(dest: any): string {
		return dest;
	}

	public addLinkAttributes(link: HTMLAnchorElement, url: string, newWindow?: boolean | undefined): void {
		link.setAttribute("href", url);

		if (newWindow) {
			link.setAttribute("target", "_blank");
		}
	}

	public set externalLinkEnabled(arg: boolean) {
		this._externalLinkEnabled = arg;
	}

	public get externalLinkEnabled(): boolean {
		return this._externalLinkEnabled;
	}

	public getAnchorUrl(hash: any): string {
		return hash;
	}

	public async executeNamedAction(action: pdfAction | string): Promise<void> {
		if (!FunctionHelper.exists(this.props.portalDocument?.value)) {
			return;
		}

		let portalDocument: PortalDocument = this.props.context.documentManager.findDocument(
			this.props.portalDocument.get().id!
		);
		let documentSettings: DocumentSettings = portalDocument.getSettings();

		switch (action) {
			case pdfAction.FirstPage:
				documentSettings.activeViewer.firstPage();
				this.props.context.documentManager.updateGlobalDocumentList();
				break;
			case pdfAction.PrevPage:
				documentSettings.activeViewer.previousPage();
				this.props.context.documentManager.updateGlobalDocumentList();
				break;
			case pdfAction.NextPage:
				documentSettings.activeViewer.nextPage(await portalDocument.getNumberOfPages());
				this.props.context.documentManager.updateGlobalDocumentList();
				break;
			case pdfAction.LastPage:
				documentSettings.activeViewer.lastPage(await portalDocument.getNumberOfPages());
				this.props.context.documentManager.updateGlobalDocumentList();
				break;
		}
	}
}